// Module
var code = `<div class="grid-edit" style="{{>position}}">
    <div class="grid-edit-picker">
        <gridPicker defaultRowsSelected="{{.defaultRowsSelected}}" defaultColumnsSelected="{{.defaultColumnsSelected}}" on-selected="newGridSizeSelected"/>
    </div>
    <terceraSeparator/>
    <terceraButton name="resetSizeButton" terceraButtonStyle="js-button-gray25" text="{{.textResetButton}}" on-btnClick="resetButtonClick" />
</div>`;
// Exports
export default code;